/** Csak 0–9; üres string megmarad (törölhetsz mindent, majd új számot írsz). Összegek / értékek űrlapmezőkhöz. */
export function filterHufDigitsInput(raw) {
  return String(raw ?? '').replace(/\D/g, '');
}
